<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryOnLoad="false" :queryHandler="queryHandler"></swb-query-sort-area>
        <div class="simple-row">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="showAppliedShopDlg">新增</button>
                <button class="swb-btn swb-btn-small" @click="generalImport">导入</button>
            </div>
        </div>
        <div class="table-layout">
            <el-table :data="dataList" border style="width: 100%">
                <el-table-column prop="contractNo" label="系统合同编号" align="center" width="250"></el-table-column>
                <el-table-column prop="contractTitle" label="合同名称" width="250"></el-table-column>
                <el-table-column prop="shopName" label="机构名称"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center" width="200"></el-table-column>
                <el-table-column label="操作" align="left" width="130">
                    <template slot-scope="rows">
                        <a class="swb-btn-link" @click="deleteDate(rows.row.id)">移除</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-layout">
            <el-pagination background v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                           layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {openRetailerComListForSelectDlg} from '../retailer/selectDlg'
    import {fileUploadGroupShowDlg} from '../comn/dialog'
    import {getDefaultPageSizes} from '../../app.conf'

    import contractApi from '../../api/contract'

    let mockConfigData = {
        "queryFields": [{
            "type": "Text",
            "valueType": "String",
            "label": "机构名称",
            "code": "shopName",
            "basic": true
        }, {
            "type": "Date2",
            "valueType": "String",
            "code": "createTime",
            "label": "创建时间",
            "basic": true
        }],
        "sortFields": []
    };

    export default {
        name: 'swb-contract-applied-shop-list',
        desc: '合同适用机构列表',
        props: {
            contractId: {
                type: Number,
                default: null
            },
            contractType: {
                type: Number,
                default: null
            },
            contractOriginalNo: {
                type: String,
                default: null
            },
            realComId: {
                type: Number,
                default: null
            },
            signGroupId: {
                type: Number,
                default: null
            },
            kindId: {
                type: Number,
                default: null
            },
            bizAreaIds: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            bizFormIds: {
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        data: function () {
            return {
                // 分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                // 过滤信息
                queryConfig: mockConfigData,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                // 其他信息
                dataList: [],
                goodsPurch: {},
                servcPurch: {},
                integPurch: {}
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.goodsPurch = getEnumInfoWith("contractType", 'name', 'GoodsPurch');
            this.servcPurch = getEnumInfoWith("contractType", 'name', 'ServcPurch');
            this.integPurch = getEnumInfoWith("contractType", 'name', 'IntegPurch');
            //
            this.getDataList();
        },
        methods: {
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getDataList();
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getDataList();
            },
            getDataList() {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.contractId = self.contractId;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                // 调用查询接口
                let theLoading = MsgBox.loading();
                contractApi.getContractAppliedShopList(postData, function (result) {
                    theLoading.close();
                    if (result.type === "info") {
                        self.dataList = result.data.rows;
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getAppliedShopIds(callback) {
                let self = this;
                let theLoading = MsgBox.loading();
                contractApi.getContractAppliedShopIds({
                    contractId: self.contractId
                }, function (result) {
                    theLoading.close();
                    if (result.type === "info") {
                        callback(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 添加适用机构
            showAppliedShopDlg() {
                let self = this;
                this.getAppliedShopIds(function (selectedShopIds) {
                    let queryFilter = {
                        disabledIds: selectedShopIds,
                        realComId: self.realComId,
                        signGroupId: self.signGroupId,
                        orgType: getEnumInfoWith('orgType', 'name', 'BizUnit').value
                    };
                    // 商品采购合同，过滤区域机构ids
                    if (self.goodsPurch.value == self.contractType) {
                        if (!Utils.isNoB(self.bizAreaIds) && self.bizAreaIds.length > 0) {
                            queryFilter.bizAreaIds = self.bizAreaIds;
                        }
                    }
                    if (!Utils.isNoB(self.bizFormIds) && self.bizFormIds.length > 0) {
                        queryFilter.bizFormIds = self.bizFormIds;
                    }
                    queryFilter.filterMerchantId = self.kindId == 0;
                    openRetailerComListForSelectDlg(queryFilter, function (resultData, theDlg) {
                        theDlg.close();
                        let shopIds = resultData.pluck('id');
                        //
                        self.saveContractAppliedShopBatch(shopIds);
                    });
                });
            },
            saveContractAppliedShopBatch: function (shopIds) {
                let self = this;
                let contractId = self.contractId;
                let theLoading = MsgBox.loading();
                contractApi.saveContractAppliedShopBatch({
                    contractId: contractId,
                    shopIds: shopIds
                }, function (result) {
                    theLoading.close();
                    if (result.type === "info") {
                        self.$message.success("操作成功");
                        self.getDataList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            generalImport: function () {
                let self = this;
                let uploadParams = {
                    title: "适用机构导入",
                    fileFor: "contract.applied.shop.import",
                    fileGroup: "contract.applied.shop.import",
                    multipleFile: false,
                    usage: 'contract.applied.shop.import' //
                };
                fileUploadGroupShowDlg(uploadParams, null, function (result, theDlg) {
                    theDlg.close();
                    if (result.type === 'info') {
                        let files = result.data.files;
                        self.file = files[0];
                        // 文件是否按模版导入
                        let errorMsgList = self.file.extra.errorMsgList;
                        if (!Utils.isNoB(errorMsgList) && errorMsgList.length > 0) {
                            MsgBox.warning(errorMsgList.join("<br/>"));
                            return;
                        }
                        //
                        let appliedShopList = self.file.extra.appliedShopList || [];
                        if (appliedShopList.length <= 0) {
                            MsgBox.warning('文件中未解析机构信息');
                            return;
                        }
                        let shopIds = appliedShopList.pluck("id");
                        //
                        self.saveContractAppliedShopBatch(shopIds);
                    } else {
                        MsgBox.warning(result.message);
                    }
                }, function () {
                    let params = {
                        contractOriginalNo: self.contractOriginalNo || null,
                        realComId: self.realComId,
                        signGroupId: self.signGroupId,
                        filterMerchantId: self.kindId == 0
                    };
                    let downloadUrl = Utils.makeUrl("/api/contract/applied/shop/imp/template/download", params);
                    //
                    Utils.setPageUrl(getAppUrl(downloadUrl), '_blank');
                });
            },
            deleteDate: function (id) {
                let self = this;
                this.$confirm("移除门店以后，关联的设备同时会移除", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    let theLoading = MsgBox.loading();
                    contractApi.deleteContractAppliedShopById(postData, function (result) {
                        theLoading.close();
                        if (result.type === "info") {
                            self.$message.success("操作成功");
                            self.getDataList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/contract/ContractAppliedShopList.vue